/* eslint-disable react/prop-types, indent */
import React, { Component } from "react";
import Navbar from "react-bootstrap/lib/Navbar";
import Nav from "react-bootstrap/lib/Nav";
import NavItem from "react-bootstrap/lib/NavItem";
import NavDropdown from "react-bootstrap/lib/NavDropdown";
import MenuItem from "react-bootstrap/lib/MenuItem";
import { withRouter } from "react-router-dom";
import { Icon, Image, Flag, Dimmer, Loader } from "semantic-ui-react";
import { connect } from "react-redux";
import {
  homeAction, livelistAction, logAction,
  configAction, inventoryAction, portsAction, graphicTopologyAction,
  mediaCountersAction, interfaceCountersAction, networkAction,
  pingGraphAction, topologyAction
} from "../../actions/changeActiveItemActions";
import Strings from "../utilities/StringSelector";
import Constants from "../utilities/Constants";
import Utils from "../utilities/Utils";

const UtilsInstance = new Utils();

class BootstrapMenuBar extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      monitoringText: Strings.MONITORING_GETTING_CONNECTION,
      languageKey: localStorage.getItem(Constants.LOCAL_STORAGE_KEY),
      language: UtilsInstance.getLanguageStringFromKey(),
      isUpdatingLanguageDimmerActive: false
    };
  }

  handleLanguageChange = (language) => {
    this.setState({ isUpdatingLanguageDimmerActive: true });
    fetch(Constants.REQUEST_IP_ADDRESS + "language_POST", {
      method: "POST",
      headers: { "Content-Type": "application/json;charset=UTF-8" },
      body: JSON.stringify({ language })
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        localStorage.setItem(Constants.LOCAL_STORAGE_KEY, language);
        window.location.reload();
      })
      .catch(error => alert(Strings.UNABLE_TO_ALTER_LANGUAGE + Strings.REASON_DP + error))
      .finally(() => this.setState({ isUpdatingLanguageDimmerActive: false }));
  }

  handleSelect = (eventKey) => {
    switch (eventKey) {
      case "/":
        this.props.onChangeHome();
        this.props.history.push("/");
        break;
      case "/livelist":
        this.props.onChangeLiveList();
        this.props.history.push("/livelist");
        break;
      case "/inventory":
        this.props.onChangeInventory();
        this.props.history.push("/inventory");
        break;
      case "/ports":
        this.props.onChangePorts();
        this.props.history.push("/ports");
        break;
      case "/ethernetip":
        this.props.onChangeMaintenance();
        this.props.history.push("/ethernetip");
        break;
      case "/network":
        this.props.onChangeNetwork();
        this.props.history.push("/network");
        break;
      case "/topology":
        this.props.onChangeTopology();
        this.props.history.push("/topology");
        break;
      case "/mediaCounters":
        this.props.onChangeMediaCounters();
        this.props.history.push("/mediaCounters");
        break;
      case "/interfaceCounters":
        this.props.onChangeInterfaceCounters();
        this.props.history.push("/interfaceCounters");
        break;
      case "/pingGraph":
        this.props.onChangePingGraph();
        this.props.history.push("/pingGraph");
        break;
      case "/graphic-topology":
        this.props.onChangeGraphicTopology();
        this.props.history.push("/graphic-topology");
        break;
      case "/log":
        this.props.onChangeLog();
        this.props.history.push("/log");
        break;
      case "/config":
        this.props.onChangeConfig();
        this.props.history.push("/login-handler");
        break;
      default:
        break;
    }
  }

  render() {
    let activePage = { "activeItem": "/" + this.props.location.pathname.split("/")[1] };

    if (activePage.activeItem === "/login"
      || activePage.activeItem === "/login-handler"
      || activePage.activeItem === "/report"
      || activePage.activeItem === "/change-login"
      || activePage.activeItem === "/ts-expert-config") {
      activePage.activeItem = "/config";
    }

    const { activeItem } = activePage;

    return (
      <>
        <Navbar fluid defaultExpanded inverse collapseOnSelect style={menuStyle}>
        <Navbar.Header>
          <Navbar.Brand>
            <Image style={noBorderStyle} src={process.env.PUBLIC_URL + "/logo.png"} alt={Strings.TS_MONITOR_LOGO_ALT} href={process.env.PUBLIC_URL || "/"} size="tiny" />
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>

        <Navbar.Collapse>
          <Nav pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>

            <NavItem
              style={fontStyle}
              eventKey='/'
              active={activeItem === "/"}>
              {Strings.TS_EXPERT}
            </NavItem>

            <NavItem
              style={fontStyle}
              eventKey='/livelist'
              active={activeItem === "/livelist"}>
              {Strings.LIVE_LIST}
            </NavItem>

            <NavItem
              style={fontStyle}
              eventKey='/inventory'
              active={activeItem === "/inventory"}>
              {Strings.INVENTORY_MENU}
            </NavItem>

            <NavItem
              style={fontStyle}
              eventKey='/ports'
              active={activeItem === "/ports"}>
              {Strings.PORTS_MENU}
            </NavItem>

            <NavItem
              style={fontStyle}
              eventKey='/network'
              active={activeItem === "/network"}>
              {Strings.NETWORK_MENU}
            </NavItem>

            {/* <NavItem
              style={fontStyle}
              eventKey='/topology'
              active={activeItem === "/topology"}>
              {Strings.TOPOLOGY}
            </NavItem> */}

            <NavItem
              style={fontStyle}
              eventKey='/mediaCounters'
              active={activeItem === "/mediaCounters"}>
              {Strings.MEDIA_COUNTERS}
            </NavItem>

            <NavItem
              style={fontStyle}
              eventKey='/interfaceCounters'
              active={activeItem === "/interfaceCounters"}>
              {Strings.INTERFACE_COUNTERS}
            </NavItem>

            <NavItem
              style={fontStyle}
              eventKey='/pingGraph'
              active={activeItem === "/pingGraph"}>
              {Strings.PING_GRAPH_MENU}
            </NavItem>
            
            <NavItem
              style={fontStyle}
              eventKey='/graphic-topology'
              active={activeItem === "/graphic-topology"}>
              {Strings.GRAPHIC_TOPOLOGY_MENU}
            </NavItem>

            <NavItem
              style={fontStyle}
              eventKey='/log'
              active={activeItem === "/log"}>
              {Strings.LOG}
            </NavItem>

          </Nav>
          <Nav pullRight bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
            <NavDropdown
              id="language-dropdown"
              eventKey={this.state.languageKey}
              title={this.state.language}
              onSelect={this.handleLanguageChange}>
              <MenuItem eventKey="pt"><Flag name="br" />{Strings.PORTUGUESE}</MenuItem>
              <MenuItem eventKey="en"><Flag name="us" />{Strings.ENGLISH}</MenuItem>
              <MenuItem eventKey="es"><Flag name="es" />{Strings.SPANISH}</MenuItem>
            </NavDropdown>
            <NavItem
              style={fontStyle}
              eventKey='/config'
              active={activeItem === "/config"}>
              <Icon name="cog" />
              {Strings.CONFIGURATIONS_MENU}
            </NavItem>
          </Nav>
        </Navbar.Collapse>

        </Navbar>
        <Dimmer page active={this.state.isUpdatingLanguageDimmerActive}>
        <Loader size="big">{Strings.UPDATING_LANGUAGE_WAITING}</Loader>
        </Dimmer>
      </>
    );
  }
}

const mapStateToProps = state => ({
  active: state.activeMenuItem
});

const mapActionsToProps = {
  onChangeHome: homeAction,
  onChangeLiveList: livelistAction,
  onChangeGraphicTopology: graphicTopologyAction,
  onChangeLog: logAction,
  onChangeConfig: configAction,
  onChangeInventory: inventoryAction,
  onChangePorts: portsAction,
  onChangeMediaCounters: mediaCountersAction,
  onChangeInterfaceCounters: interfaceCountersAction,
  onChangeNetwork: networkAction,
  onChangePingGraph: pingGraphAction,
  onChangeTopology: topologyAction
};

const menuStyle = {
  backgroundColor: "#262626",
  padding: "8pt",
  borderRadius: "0pt",
  borderWidth: 0
};

const fontStyle = {
  fontSize: "medium",
};

const noBorderStyle = {
  marginTop: "-4pt",
};

export default connect(mapStateToProps, mapActionsToProps)(withRouter(BootstrapMenuBar));
